/**
 * Day.js configuration with required plugins
 *
 * This module configures dayjs with plugins needed to replace moment.js:
 * - relativeTime: for .fromNow() functionality
 * - customParseFormat: for parsing dates with specific formats
 * - localizedFormat: for locale-aware format tokens like 'll'
 *
 * Import dayjs from this module instead of 'dayjs' directly to ensure
 * plugins are loaded.
 */
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'

// Extend dayjs with required plugins
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(localizedFormat)

export default dayjs
